const { useMemo, useRef } = require('react');

module.exports = function useCompositePreferencesHandle() {

    const preferencesControllersRef = useRef([]);
    const compositeControllerRef = useRef(null);

    if (!compositeControllerRef.current) {
        compositeControllerRef.current = {
            get fields() {

                return preferencesControllersRef.current.flatMap((controller) => {

                    if (!Array.isArray(controller?.fields)) {
                        return [];
                    }

                    return controller.fields;
                });
            },
            validate(field) {

                const controller = preferencesControllersRef.current.find((nextController) => {

                    return Array.isArray(nextController?.fields)
                        && nextController.fields.includes(field);
                });

                if (typeof controller?.validate !== 'function') {
                    return null;
                }

                return controller.validate(field);
            },
            submit() {

                return preferencesControllersRef.current.reduce((valid, controller) => {

                    if (typeof controller?.submit !== 'function') {
                        return valid;
                    }

                    return controller.submit() !== false && valid;
                }, true);
            },
            getUserPreferences() {

                return preferencesControllersRef.current.reduce((collector, controller) => {

                    if (typeof controller?.getUserPreferences !== 'function') {
                        return collector;
                    }

                    return {
                        ...collector,
                        ...(controller.getUserPreferences() || {})
                    };
                }, {});
            },
            hasErrors() {

                return preferencesControllersRef.current.some((controller) => {

                    return typeof controller?.hasErrors === 'function'
                        && controller.hasErrors();
                });
            }
        };
    }

    return useMemo(() => ({
        get current() {

            return compositeControllerRef.current;
        },
        register(nextPreferencesController) {

            if (!nextPreferencesController || preferencesControllersRef.current.includes(nextPreferencesController)) {
                return;
            }

            preferencesControllersRef.current = preferencesControllersRef.current.concat(nextPreferencesController);
        },
        unregister(nextPreferencesController) {

            preferencesControllersRef.current = preferencesControllersRef.current.filter((controller) => {

                return controller !== nextPreferencesController;
            });
        },
        getUserPreferences() {

            return compositeControllerRef.current.getUserPreferences();
        },
        hasErrors() {

            return compositeControllerRef.current.hasErrors();
        }
    }), []);
};
